<template>
  <div v-show="visible">
    <div class="header">
      <div class="back" @click="showLoginView"><i class="fas fa-long-arrow-alt-left"></i></div>
      <div class="find-pw-header">비밀번호 찾기</div>
    </div>
    <div class="body password" v-loading="loading">
      <el-form class="find-pw-view" ref="passwordForm" :model="passwordData" :rules="passwordFormRules" :show-message="false" :status-icon="true">
        <el-form-item prop="id" required>
          <div>
            <el-input placeholder="ID" ref="idField" v-model="passwordData.id" required clearable> </el-input>
          </div>
        </el-form-item>
        <el-form-item style="margin-bottom: 0px" prop="question" required>
          <el-select class="pw-question" placeholder="질문" v-model="passwordData.question" required clearable>
            <el-option v-for="item in pwQuestionList" :key="item.basicinfoSubid" :label="item.basicinfoSubname" :value="item.basicinfoSubid"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="answer" required>
          <el-input placeholder="답변" v-model="passwordData.answer" required clearable @keyup.enter.native="sendPasswordResetEmail"> </el-input>
        </el-form-item>
      </el-form>
      <!-- message -->
      <div class="message-view">
        <el-row v-show="success === false && message !== null" type="flex" justify="center" class="error">
          <i class="fas fa-exclamation-circle" style="margin-right:4px;"></i><span>{{ message }}</span>
        </el-row>
      </div>
      <el-button @click="sendPasswordResetEmail"> 비밀번호 초기화 이메일 발송 </el-button>
    </div>
  </div>
</template>

<script>
import loginApi from '@/api/login';
import messageUtil from '@/utils/message';
import { PASSWORD_RESET_STATUS } from '@/constants/password';

export default {
  name: 'WPasswordView',
  props: {
    visible: {
      type: Boolean,
    },
    downloadUrl: {
      type: String,
    },
  },
  data() {
    return {
      passwordData: {
        id: '',
        question: '',
        answer: '',
      },
      /**
       * 로그인 폼 유효성 검사 조건
       * @type {Object}
       */
      passwordFormRules: {
        id: [
          {
            required: true,
            trigger: 'change',
          },
        ],
        question: [
          {
            required: true,
            trigger: 'change',
          },
        ],
        answer: [
          {
            required: true,
            trigger: 'change',
          },
        ],
      },
      message: null,
      success: false,
      loading: false,
      pwQuestionList: [],
    };
  },
  watch: {
    /**
     * 활성화된 뷰가 변경될 경우 각 뷰의 초기화 작업을 해준다.
     * @author Ju
     * @param  {[type]} to [description]
     * @return {[type]}    [description]
     */
    visible(to) {
      if (to) {
        this.$refs.idField.focus();
        this.reset();
      }
    },
  },
  created() {
    loginApi.getPasswordQuestions().then((response) => {
      const result = response.data;
      if (result.success) {
        this.pwQuestionList = result.data;
      }
    });
  },
  methods: {
    sendPasswordResetEmail() {
      this.$refs.passwordForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          const data = this.passwordData;
          loginApi
            .resetPassword(data.id, data.question, data.answer)
            .then((response) => {
              this.loading = false;
              const result = response.data;
              this.success = result.success;
              if (this.success === true) {
                this.$message(messageUtil.getCustomResultMsgData(PASSWORD_RESET_STATUS[result.message], true));
                this.showLoginView();
              } else {
                this.message = PASSWORD_RESET_STATUS[result.message] || '비밀번호를 초기화하지 못하였습니다';
              }
            })
            .catch(() => {
              this.loading = false;
              this.success = false;
              this.message = '비밀번호를 초기화하지 못하였습니다.';
            });
        } else {
          this.success = false;
          this.message = '아이디와 질문, 답변을 입력해주십시오.';
        }
      });
    },
    /**
     * 로그인 화면으로 전환한다.
     * @author Ju
     * @return {[type]} [description]
     */
    showLoginView() {
      this.$emit('login-view-show');
    },
    reset() {
      this.passwordData = {
        id: '',
        question: '',
        answer: '',
      };
      this.message = null;
      this.success = false;
      this.loading = false;
      this.$refs.passwordForm.resetFields();
    },
  },
};
</script>

<style module>
/* .body-wrapper {
  width: 100%;
  height: calc(100% - 110px);
  padding: 5px;
} */
</style>



// WEBPACK FOOTER //
// src/views/login/components/PasswordView.vue